import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}(); // FHT Swagger jQuery client V2

/* eslint-disable */


import { BaseApi } from "./api";

var TouristChatApiApi =
/** @class */
function (_super) {
  __extends(TouristChatApiApi, _super);

  function TouristChatApiApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.touristChatApiCreateNewTouristChatAsync = function (p) {
      var localVarPath = '/api/touristChat/createNewTouristChat';

      _this.r(p, ["otherUserClientId", "touristClientId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.touristChatApiGet = function (p) {
      var localVarPath = '/api/touristChat';

      _this.r(p, ["touristChatId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.touristChatApiGetByTouristClientId = function (p) {
      var localVarPath = '/api/touristChat/byTouristClientId';

      _this.r(p, ["touristClientId", "model.authHash"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.touristChatApiGetForTourist = function (p) {
      var localVarPath = '/api/touristChat/forTourist';

      _this.r(p, ["otherUserClientId", "touristClientId", "model.authHash"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    return _this;
  }

  return TouristChatApiApi;
}(BaseApi);

export { TouristChatApiApi };